import { getIsFileExternal, getIsFilePrivate } from './fileAccessibility';
import { getIsSvgTooLarge, getIsSvg } from './file';
export const getThumbnailTooltipI18nKey = (file, isHostAppContextPrivate = false) => {
  let tooltipI18nKey = 'FileManagerLib.generatingThumbnailInsertTooltip';
  if (getIsSvg(file) && getIsSvgTooLarge(file)) {
    tooltipI18nKey = 'FileManagerCore.tooltips.fileTooLargeToPreview';
  }
  if (getIsFilePrivate(file) && !isHostAppContextPrivate) {
    tooltipI18nKey = 'FileManagerLib.privateFileInsertTooltip';
  }
  if (getIsFileExternal(file)) {
    tooltipI18nKey = 'FileManagerLib.externalFileInsertTooltip';
  }
  return tooltipI18nKey;
};